import {
  GET_TARGETS,
  GET_TARGET,
  SAVE_TARGET,
  DELETE_TARGET,
} from "./actions.type";
import {
  SET_TARGETS,
  SET_TARGET,
  SAVING_TARGET,
  DELETING_TARGET,
  TARGETS_LOADING,
  TARGET_LOADING,
} from "./mutations.type";
import {
  getTargets,
  getTarget,
  deleteTarget,
  saveTarget,
} from "@/services/targets/target.service";

const STATE = {
  loading: false,
  loadingList: false,
  saving: false,
  deleting: false,
  error: null,
  alerts: [],
};

const GETTERS = {
  loading: (state) => state.loading,
  loadingList: (state) => state.loadingList,
  alerts: (state) => state.alerts,
  saving: (state) => state.saving,
  deleting: (state) => state.deleting,
};

const ACTIONS = {
  async [GET_TARGETS](context, params) {
    try {
      context.commit(TARGETS_LOADING, true);
      let RESULT = await getTargets(params);
      context.commit(SET_TARGETS, RESULT);
    } catch (error) {
      console.error("Error in GET_TARGETS actions: " + error);
    } finally {
      context.commit(TARGETS_LOADING, false);
    }
  },
  async [GET_TARGET](context, params) {
    try {
      context.commit(TARGET_LOADING, true);
      let RESULT = await getTarget(params);
      context.commit(SET_TARGET, RESULT);
    } catch (error) {
      console.error("Error in GET_TARGET actions: " + error);
    } finally {
      context.commit(TARGET_LOADING, false);
    }
  },
  async [DELETE_TARGET](context, params) {
    try {
      context.commit(DELETING_TARGET, true);
      await deleteTarget(params);
      context.commit(DELETING_TARGET, false);
      context.dispatch(GET_TARGETS);
    } catch (error) {
      console.error("Error in DELETE_TARGET actions: " + error);
    } finally {
      context.commit(DELETING_TARGET, false);
    }
  },
  async [SAVE_TARGET](context, params) {
    try {
      context.commit(SAVING_TARGET, true);
      await saveTarget(params);
      context.commit(SAVING_TARGET, false);
      context.dispatch(GET_TARGETS);
    } catch (error) {
      console.error("Error in SAVE_TARGET actions: " + error);
    } finally {
      context.commit(SAVING_TARGET, false);
    }
  },
};

const MUTATIONS = {
  [TARGETS_LOADING](state, data) {
    state.loadingList = data;
  },
  [TARGET_LOADING](state, data) {
    state.loading = data;
  },
  [SET_TARGETS](state, data) {
    state.targets = data;
  },
  [SET_TARGET](state, data) {
    state.target = data;
  },
  [SAVING_TARGET](state, data) {
    state.saving = data;
  },
  [DELETING_TARGET](state, data) {
    state.deleting = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
